import { SnapGuide } from '@src/components/timeline/SnapGuide';
import React from 'react';

import { EndMarker } from './EndMarker';
import { Playhead } from './Playhead';
import { Tickmarks } from './Tickmarks';

interface TimelineHeaderProps {
  scale: number;
  duration: number;
  currentTime: number;
  maxWidth: number;
  extraTimeWidth: number;
  refScrollLeft: number;
  trackHeight: number;
}

export const TimelineHeader: React.FC<TimelineHeaderProps> = ({
  maxWidth,
  extraTimeWidth,
  refScrollLeft,
  trackHeight,
}) => {
  return (
    <>
      <Tickmarks
        maxWidth={maxWidth + extraTimeWidth}
        refScrollLeft={refScrollLeft}
      />
      <div
        onMouseDown={e => {
          e.stopPropagation();
        }}
      >
        <EndMarker />
        <Playhead trackHeight={trackHeight} />
        <SnapGuide />
      </div>
    </>
  );
};
